
import React, { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import * as postServices from "../services/post";
import api from "../services/api";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(
    localStorage.getItem("authToken") || null
  );
  const [refreshToken, setRefreshToken] = useState(
    localStorage.getItem("refreshToken") || null
  );
  const [partnerType, setPartnerType] = useState(
    localStorage.getItem("partnerType") || null  // Add userType
  );
  const [partnerId, setPartnerId] = useState(
    localStorage.getItem("partnerId") || null 
  );

  useEffect(() => {
    if (authToken) {
      localStorage.setItem("authToken", authToken);
      const decoded = jwtDecode(authToken);
      setPartnerId(decoded.sub);
      localStorage.setItem("partnerId", decoded.sub);
      api.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;
    } else {
      localStorage.removeItem("authToken");
      delete api.defaults.headers.common["Authorization"];
    }
  }, [authToken]);

  const handleLogin = async (email, password) => {
    try {
      const response = await postServices.login(email, password);
      setAuthToken(response.access_token);
      setRefreshToken(response.refresh_token);
      setPartnerType(response.partner_type);  // Store userType
      localStorage.setItem("refreshToken", response.refresh_token);
      localStorage.setItem("partnerType", response.partner_type);  // Persist userType in localStorage
      return response;
    } catch (error) {
      console.error("Failed to login:", error);
      throw error;
    }
  };

  const handleLogout = () => {
    setAuthToken(null);
    setRefreshToken(null);
    setPartnerType(null);  // Clear userType
    setPartnerId(null);
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("partnerType");  // Remove userType from localStorage
    localStorage.removeItem("partnerId");
    delete api.defaults.headers.common["Authorization"];
  };
  return (
    <AuthContext.Provider
      value={{
        authToken,
        setAuthToken,
        refreshToken,
        setRefreshToken,
        partnerType,  // Pass partnerType through context
        handleLogin,
        handleLogout,
        partnerId
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
